<template>
  <highcharts :options="chartOptions" />
</template>

<script>
  import { Chart } from 'highcharts-vue'
  export default {
    components: {
      highcharts: Chart
    },
    props: {
      height: {
        type: String,
        default: null
      },
      series: {
        type: Array,
        default: null
      },
      start: {
        type: Object,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      yAxis: {
        type: Array,
        default: () => [{
          gridLineWidth: 1,
          tickWidth: 1,
          title: {
            text: 'Value'
          }
        }]
      },
      isMoney: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const theme = this.$vuetify.theme.themes.dark
      const formatMoney = this.formatMoney
      return {
        chartOptions: {
          tooltip: {
            pointFormatter: this.isMoney
              ? function () {
                const value = formatMoney(this.y)
                return (
                  '<span style="color:' +
                  this.series.color +
                  '">' +
                  this.series.name +
                  '</span>: <b>' +
                  value +
                  '</b><br />'
                )
              }
              : null
          },
          colors: Object.values(theme), // chart colors
          title: {
            text: this.title,
            align: 'left',
            style: {
              fontFamily: 'Roboto',
              fontWeight: 'bold'
            }
          },
          subtitle: {
            align: 'left',
            style: {
              fontFamily: 'Roboto Condensed'
            }
          },
          legend: {
            align: 'right',
            verticalAlign: 'bottom'
          },
          chart: {
            zoomType: 'xy',
            backgroundColor: 'transparent',
            style: {
              fontFamily: 'Roboto'
            },
            height: this.height
          },
          credits: {
            enabled: false
          },
          yAxis: this.yAxis,
          xAxis: {
            gridLineWidth: 1,
            tickWidth: 1,
            type: 'datetime',
            title: {
              text: 'Date'
            }
          },
          plotOptions: {
            series: {
              pointStart: this.start,
              pointInterval: 24 * 3600 * 1000 // one day
            },
            column: {
              stacking: 'normal'
            },
            line: {
              marker: {
                enabled: false
              }
            },
            spline: {
              marker: {
                enabled: false
              }
            },
            area: {
              marker: {
                enabled: false
              }
            },
            areaspline: {
              marker: {
                enabled: false
              }
            },
            arearange: {
              marker: {
                enabled: false
              }
            },
            bubble: {
              maxSize: '10%'
            }
          },
          series: this.series
        }
      }
    }
  }
</script>
